<template>
    <div class="px-3">
        <v-row v-if="selected_months.length > 0">
            <v-col cols="3"> </v-col>
            <v-col cols="3" justify="center" align="center"> 
                <v-row justify="center" align="center">
                    <h5 class="pb-2">{{ selected_months[0][$store.state.language] }}</h5> 
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="!month1.sorted" @click="month1.sorted = true; month1.direction = 'desc'; sortResults(info.states, year.toString() + '-' + String(selected_months[0].month + 1).padStart(2, '0'), 'desc', 'month1')">
                        <v-icon>unfold_more</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month1.sorted && month1.direction == 'desc'" @click="month1.sorted = true; month1.direction = 'asc'; sortResults(info.states, year.toString() + '-' + String(selected_months[0].month + 1).padStart(2, '0'), 'asc', 'month1')">
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month1.sorted && month1.direction == 'asc'" @click="month1.sorted = false; month1.direction = ''; sortResults(info.states, null, '', 'month1')">
                        <v-icon>keyboard_arrow_up</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
            <v-col cols="3" justify="center" align="center"> 
                <v-row justify="center" align="center">
                    <h5 class="pb-2">{{ selected_months[1][$store.state.language] }}</h5> 
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="!month2.sorted" @click="month2.sorted = true; month2.direction = 'desc'; sortResults(info.states, year.toString() + '-' + String(selected_months[1].month + 1).padStart(2, '0'), 'desc', 'month2')">
                        <v-icon>unfold_more</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month2.sorted && month2.direction == 'desc'" @click="month2.sorted = true; month2.direction = 'asc'; sortResults(info.states, year.toString() + '-' + String(selected_months[1].month + 1).padStart(2, '0'), 'asc', 'month2')">
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month2.sorted && month2.direction == 'asc'" @click="month2.sorted = false; month2.direction = ''; sortResults(info.states, null, '', 'month2')">
                        <v-icon>keyboard_arrow_up</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
            <v-col cols="3" justify="center" align="center"> 
                <v-row>
                    <v-col cols="10" class="pl-12">
                        <v-row justify="center" align="center">
                            <h5 class="pb-2">{{ selected_months[2][$store.state.language] }}</h5>
                            <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="!month3.sorted" @click="month3.sorted = true; month3.direction = 'desc'; sortResults(info.states, year.toString() + '-' + String(selected_months[2].month + 1).padStart(2, '0'), 'desc', 'month3')">
                                <v-icon>unfold_more</v-icon>
                            </v-btn>
                            <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month3.sorted && month3.direction == 'desc'" @click="month3.sorted = true; month3.direction = 'asc'; sortResults(info.states, year.toString() + '-' + String(selected_months[2].month + 1).padStart(2, '0'), 'asc', 'month3')">
                                <v-icon>keyboard_arrow_down</v-icon>
                            </v-btn>
                            <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month3.sorted && month3.direction == 'asc'" @click="month3.sorted = false; month3.direction = ''; sortResults(info.states, null, '', 'month3')">
                                <v-icon>keyboard_arrow_up</v-icon>
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="1" class="px-0 mx-0 py-0 mb-2">
                        <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" @click="leftMonth">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" class="px-0 mx-0 py-0 mb-2">
                        <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" @click="rightMonth">
                            <v-icon>chevron_right</v-icon>    
                        </v-btn>
                    </v-col>
                </v-row>    
            </v-col>
        </v-row>

        <div class="horizontal-separator-bold"></div>

        <v-row class="py-0 my-0" style="font-weight: bold;">
            <v-col class="py-0"> <h5>{{ $t('yego_dashboard.state')}}</h5> </v-col>
            <v-col cols="3"> 
                <v-row justify="center">
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.nominal_value')}}</h5> </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.percentaje_value')}}</h5> </v-col>
                </v-row>
            </v-col>
            <v-col cols="3"> 
                <v-row justify="center">
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.nominal_value')}}</h5> </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.percentaje_value')}}</h5> </v-col>
                </v-row>
            </v-col>
            <v-col cols="3"> 
                <v-row justify="center">
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.nominal_value')}}</h5> </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.percentaje_value')}}</h5> </v-col>
                </v-row>
            </v-col>
        </v-row>

        <div class="horizontal-separator-bold"></div>

        <!-- Total -->
        <span style="font-size: 12px;" v-if="info.states != null">
            <v-row v-for="prop in ['nominal', 'buyout']" :key="prop" class="my-1">
                <v-col cols="3" class="pl-6 my-0 py-0">
                    <h4 v-if="prop == 'nominal'">{{ info.states.find(x => x.name == 'TOTAL MÉXICO' && x.is_total == true).name }}</h4>
                    <h4 v-else>{{ $t('yego_dashboard.total_' + prop) }}</h4>
                </v-col>
                <v-col cols="3" v-for="(month, i) in selected_months" :key="i">
                    <span v-for="(value_month, index) in info.states.find(x => x.name == 'TOTAL MÉXICO' && x.is_total == true).months" :key="index">   
                        <v-row v-if="(parseInt(month.month) + 1) == parseInt(index.split('-')[1])">
                            <v-col cols="5" justify="center" align="center" class="my-0 py-0"> 
                                {{ value_month[prop]['formatted'] }}
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" justify="center" align="center" class="my-0 py-0">
                                {{ value_month[prop]['percentage'] }}
                            </v-col>
                        </v-row>
                    </span>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <div class="horizontal-separator"></div>
        </span>

        <!-- Calculated Rows -->
        <span v-if="info.states != null">
            <span v-for="(state, index) of info.states.filter(x => x.is_total == false)" :key="index" style="font-size: 12px;">
                <v-row v-for="prop in ['nominal', 'buyout']" :key="prop" class="my-1">
                    <v-col cols="3" class="pl-6 my-0 py-0">
                        <h4 v-if="prop == 'nominal'">{{ state.name }}</h4>
                        <h4 v-else>{{ $t('yego_dashboard.' + prop) }}</h4>
                    </v-col>
                    <v-col cols="3" v-for="(month, i) in selected_months" :key="i">
                        <span v-for="(value_month, index) in state.months" :key="index">   
                            <v-row v-if="(parseInt(month.month) + 1) == parseInt(index.split('-')[1])" :class="prop == 'buyout' ? calculateClass(parseFloat(value_month[prop]['percentage'].replace('%', ''))) : ''">
                                <v-col cols="5" justify="center" align="center" class="my-0 py-0"> 
                                    {{ value_month[prop]['formatted'] }}
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="5" justify="center" align="center" class="my-0 py-0">
                                    {{ value_month[prop]['percentage'] }}
                                </v-col>
                            </v-row>
                        </span>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>

                <div class="horizontal-separator"></div>
            </span>
        </span>
    </div>
</template>
<script>
    export default {
        props: [
            'data',
            'options',
            'selected_months',
            'year',
        ],
        data() {
            return {
                info: {},
                month1: { sorted: false, direction: '' },
                month2: { sorted: false, direction: '' },
                month3: { sorted: false, direction: '' },
                state_with_most_deliveries: { name: "", value: 0}
            }
        },
        methods: {
            calculateClass(percentaje) {
                if(percentaje == 0) return "";
                else if(percentaje >= this.options.green.min) return "green_text";
                else return "red_text"; 
            },
            leftMonth() {
                this.$emit("leftMonth");
            },
            rightMonth() {
                this.$emit("rightMonth");
            },
            sortResults(obj, key = null, direction = "asc", month){
                if(direction == "") {
                    this.info = {
                        ...this.data,
                        states: [...this.data.states]
                    };
                    return;
                }

                if((this[month] != this.month1 && this.month1.sorted == true) || (this[month] != this.month2 && this.month2.sorted == true) || (this[month] != this.month3 && this.month3.sorted == true)){
                    this.cleanSort();
                    return;
                }

                const sorted = obj.sort((a, b) => {
                    const aMonth = a.months?.[key];
                    const bMonth = b.months?.[key];
            
                    if (!aMonth && bMonth) return 1;
                    if (aMonth && !bMonth) return -1;
                    if (!aMonth && !bMonth) return 0;

                    const percA = Number(aMonth.buyout?.percentage_value ?? 0);
                    const percB = Number(bMonth.buyout?.percentage_value ?? 0);

                    return direction === "asc"
                        ? percA - percB
                        : percB - percA;
                });

                this.info.states = sorted;
            },
            cleanSort(){
                this.month1.sorted = false;
                this.month1.direction = "";

                this.month2.sorted = false;
                this.month2.direction = "";

                this.month3.sorted = false;
                this.month3.direction = "";
                
                this.info = {
                    ...this.data,
                    states: [...this.data.states]
                };
            }
        },
        watch: {
            'data': function(){
                this.info = {
                    ...this.data,
                    states: [...this.data.states]
                };
            }
        }
    }
</script>